import { useQuery } from 'react-query'
import useAxios from './useAxios'

const useContact = () => {
	const { getContact } = useAxios()
	const { isLoading, data } = useQuery('contactezNous', getContact)

	if (isLoading) return { isLoading }

	const { title, content, entete } = data

	const parts = entete && entete.split('\r\n')

	return {
		isLoading,
		title,
		content,
		phone: parts && parts[0],
		email: parts && parts[1],
	}
}

export default useContact
